/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserAccountChangeRequest} from '../models/UserAccountChangeRequest';
import type {UserSearchesReplaceResponse} from '../models/UserSearchesReplaceResponse';

export interface UserAccountChangeV2$Request {
    userId: number;
    userAccountChangeRequest: UserAccountChangeRequest;
}

export interface UserAccountChangeV2$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const userAccountChangeV2Request = createAction<PayloadData<void, UserAccountChangeV2$Request>>('USER_ACCOUNT_CHANGE_V2__USER_ACCOUNT_CHANGE_V2__REQUEST');
export const userAccountChangeV2Success = createAction<PayloadData<UserSearchesReplaceResponse, UserAccountChangeV2$Request>>('USER_ACCOUNT_CHANGE_V2__USER_ACCOUNT_CHANGE_V2__SUCCESS');
export const userAccountChangeV2Failure = createAction<PayloadData<Error, UserAccountChangeV2$Request, true>>('USER_ACCOUNT_CHANGE_V2__USER_ACCOUNT_CHANGE_V2__FAILURE');

export const userAccountChangeV2Actions = [
    userAccountChangeV2Request,
    userAccountChangeV2Success,
    userAccountChangeV2Failure
] as const;

/**
 * @param {number} meta.userId
 * @param {UserAccountChangeRequest} meta.userAccountChangeRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const userAccountChangeV2 = (meta: UserAccountChangeV2$Request, config?: UserAccountChangeV2$Config) => {
    return {
        CALL_API: {
            types: userAccountChangeV2Actions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/v2/users/${meta.userId}/change-account`,
            TRANSPORT_REQUEST_BODY: meta.userAccountChangeRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

